import { render, staticRenderFns } from "./OldStu.vue?vue&type=template&id=ab4539a6&"
import script from "./OldStu.vue?vue&type=script&lang=js&"
export * from "./OldStu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports